export const VFX_SPRITE_FRAME_COUNT_DATA: Record<string, number> = {
  // SIMPLE PROJECTILES
  "/assets/spells/projectile/razor-leaf.png": 4,
  "/assets/spells/projectile/ember.png": 4,
  "/assets/spells/projectile/bubble.png": 7,
  "/assets/spells/projectile/thunder-shock.png": 7,
  "/assets/spells/projectile/ice-shard.png": 8,
  "/assets/spells/projectile/acid.png": 8,
  "/assets/spells/projectile/mud-shot.png": 8,
  "/assets/spells/projectile/gust.png": 4,
  "/assets/spells/projectile/psy-ball.png": 16,
  "/assets/spells/projectile/bug-buzz.png": 12,
  "/assets/spells/projectile/rock-throw.png": 8,
  "/assets/spells/projectile/shadow-dagger.png": 8,
  "/assets/spells/projectile/scale-shot.png": 8,
  "/assets/spells/projectile/dark-pulse.png": 8,
  "/assets/spells/projectile/scrap-throw.png": 16,
  "/assets/spells/projectile/sweet-kiss.png": 3,
  "/assets/spells/projectile/triattack__4.png": 4,
  "/assets/spells/projectile/bonemerang_000__8.png": 8,

  // PROJECTILE PLLUS
  "/assets/spells/projectile/supersonic.png": 16,
  "/assets/spells/projectile/fire-ball.png": 8,
  "/assets/spells/projectile/bubble-beam.png": 7,
  "/assets/spells/projectile/bullet-seed.png": 8,
  "/assets/spells/projectile/thunderbolt.png": 8,
  "/assets/spells/projectile/icicle-dagger.png": 8,
  "/assets/spells/projectile/sludge-bomb.png": 14,
  "/assets/spells/projectile/mud-bomb.png": 14,
  "/assets/spells/projectile/chatter.png": 16,
  "/assets/spells/projectile/psy-pulse.png": 30,
  "/assets/spells/projectile/string-shot.png": 1,
  "/assets/spells/projectile/rock-slide.png": 8,
  "/assets/spells/projectile/shadow-ball.png": 32,
  "/assets/spells/projectile/dragon-pulse.png": 32,
  "/assets/spells/projectile/flatter.png": 10,
  "/assets/spells/projectile/magnet-bomb.png": 16,
  "/assets/spells/projectile/dazzling-gleam.png": 8,
  "/assets/spells/projectile/energy-ball.png": 12,
  "/assets/spells/projectile/confuse-ray.png": 4,

  // IMPACT VFX
  "/assets/spells/impact/melee-1-white.png": 7,
  "/assets/spells/impact/melee-1-blue.png": 7,
  "/assets/spells/impact/melee-1-green.png": 7,
  "/assets/spells/impact/melee-1-red.png": 7,
  "/assets/spells/impact/melee-1-yellow.png": 7,
  "/assets/spells/impact/melee-1-pink.png": 7,
  "/assets/spells/impact/melee-1-orange.png": 7,
  "/assets/spells/impact/melee-white-2.png": 5,
  "/assets/spells/impact/fantasy-black-1.png": 8,
  "/assets/spells/impact/fantasy-pink-1.png": 8,
  "/assets/spells/impact/fantasy-green-1.png": 8,
  "/assets/spells/impact/impfx1_toon_impact_B_large_white.png": 7,
  "/assets/spells/impact/ranged-ground-1.png": 11,
  "/assets/spells/impact/ranged-water-1.png": 11,
  "/assets/spells/impact/ranged-electric-1.png": 11,
  "/assets/spells/impact/scifi-white-1.png": 10,
  "/assets/spells/impact/magic-pink-1.png": 11,
  "/assets/spells/impact/toon-white-1.png": 8,
  "/assets/spells/impact/fanfx1_skull_puff_large_white.png": 12,
  "/assets/spells/impact/fanfx1_skull_puff_large_blue.png": 12,
  "/assets/spells/impact/fanfx1_skull_puff_large_red.png": 12,
  "/assets/spells/impact/impfx2_scifi_impact_B_large_white.png": 9,
  "/assets/spells/impact/melee-dragon-3.png": 6,
  "/assets/spells/impact/bonemerang_001__6.png": 6,
  "/assets/spells/impact/fx3_splatter_large_orange.png": 10,
  "/assets/spells/impact/fx3_smoke_bomb_large_black.png": 10,
  "/assets/spells/impact/impfx2_dust_impact_A_large_violet.png": 9,

  // TILE VFX - Magic Puff
  "/assets/spells/tile-fx/magic-puff-black.png": 12,
  "/assets/spells/tile-fx/magic-puff-white.png": 12,
  "/assets/spells/tile-fx/magic-puff-blue.png": 12,
  "/assets/spells/tile-fx/magic-puff-green.png": 12,
  "/assets/spells/tile-fx/magic-puff-orange.png": 12,
  "/assets/spells/tile-fx/magic-puff-red.png": 12,
  "/assets/spells/tile-fx/magic-puff-yellow.png": 12,
  "/assets/spells/tile-fx/magic-puff-pink.png": 12,

  // MELEE CAST - Bites
  "/assets/spells/melee-cast/crunch.png": 17,
  "/assets/spells/melee-cast/dragon-fang.png": 17,
  "/assets/spells/melee-cast/shadow-claws.png": 17,
  "/assets/spells/melee-cast/behemoth-bash.png": 17,
  "/assets/spells/melee-cast/spirit-break.png": 17,
  "/assets/spells/melee-cast/poison-fang.png": 17,
  "/assets/spells/melee-cast/psychic-fangs.png": 17,
  "/assets/spells/melee-cast/bug-bite.png": 17,
  "/assets/spells/melee-cast/fire-fang.png": 17,
  "/assets/spells/melee-cast/thunder-fang.png": 17,
  "/assets/spells/melee-cast/ice-fang.png": 17,

  // MELEE CAST - Claws
  "/assets/spells/melee-cast/fire-claw.png": 10,
  "/assets/spells/melee-cast/ice-claw.png": 10,
  "/assets/spells/melee-cast/electric-claw.png": 10,
  "/assets/spells/melee-cast/grass-claw.png": 10,
  "/assets/spells/melee-cast/poison-claw.png": 10,
  "/assets/spells/melee-cast/rock-claw.png": 10,
  "/assets/spells/melee-cast/bug-claw.png": 10,
  "/assets/spells/melee-cast/dark-claw.png": 10,
  "/assets/spells/melee-cast/steel-claw.png": 10,
  "/assets/spells/melee-cast/fairy-claw.png": 10,

  // MELEE CAST - Slash
  "/assets/spells/melee-cast/slash-red.png": 9,
  "/assets/spells/melee-cast/slash-white.png": 9,
  "/assets/spells/melee-cast/slash-blue.png": 9,
  "/assets/spells/melee-cast/slash-orange.png": 9,
  "/assets/spells/melee-cast/slash-black.png": 9,
  "/assets/spells/melee-cast/slash-green.png": 9,
  "/assets/spells/melee-cast/slash-pink.png": 9,

  // TILE FX
  "/assets/spells/tile-fx/water-1.png": 16,
  "/assets/spells/tile-fx/water-2.png": 10,
  "/assets/spells/tile-fx/dragon-1.png": 8,
  "/assets/spells/tile-fx/fire-1.png": 9,
  "/assets/spells/tile-fx/fire-2.png": 7,
  "/assets/spells/tile-fx/fire-3.png": 11,
  "/assets/spells/tile-fx/fire-4.png": 9,
  "/assets/spells/tile-fx/fire-5.png": 1,
  "/assets/spells/tile-fx/fire-6.png": 23,
  "/assets/spells/tile-fx/grass-1.png": 9,
  "/assets/spells/tile-fx/poison-1.png": 12,
  "/assets/spells/tile-fx/poison-2.png": 4,
  "/assets/spells/tile-fx/poison-3.png": 12,
  "/assets/spells/tile-fx/poison-4.png": 17,
  "/assets/spells/tile-fx/ground-1.png": 7,
  "/assets/spells/tile-fx/ground-2.png": 6,
  "/assets/spells/tile-fx/ground-3.png": 31,
  "/assets/spells/tile-fx/ground-4.png": 27,
  "/assets/spells/tile-fx/electric-1.png": 10,
  "/assets/spells/tile-fx/electric-2.png": 16,
  "/assets/spells/tile-fx/fighting-1.png": 10,
  "/assets/spells/tile-fx/flying-1.png": 11,
  "/assets/spells/tile-fx/flying-1b.png": 11,
  "/assets/spells/tile-fx/flying-2.png": 4,
  "/assets/spells/tile-fx/flying-3.png": 31,
  "/assets/spells/tile-fx/rock-1.png": 11,
  "/assets/spells/tile-fx/rock-2.png": 9,
  "/assets/spells/tile-fx/bug-1.png": 16,
  "/assets/spells/tile-fx/dark-1.png": 9,
  "/assets/spells/tile-fx/dark-2.png": 8,
  "/assets/spells/tile-fx/dark-3.png": 17,
  "/assets/spells/tile-fx/ice-1.png": 12,
  "/assets/spells/tile-fx/ice-2.png": 9,
  "/assets/spells/tile-fx/ice-3.png": 10,
  "/assets/spells/tile-fx/ice-4.png": 16,
  "/assets/spells/tile-fx/psychic-1.png": 4,
  "/assets/spells/tile-fx/psychic-2.png": 10,
  "/assets/spells/tile-fx/psychic-3.png": 10,
  "/assets/spells/tile-fx/psychic-4.png": 12,
  "/assets/spells/tile-fx/psychic-5.png": 16,
  "/assets/spells/tile-fx/steel-1.png": 4,
  "/assets/spells/tile-fx/steel-2.png": 4,
  "/assets/spells/tile-fx/steel-3.png": 18,
  "/assets/spells/tile-fx/vine_whip_upwards_000__12.png": 12,
  "/assets/spells/tile-fx/red_punch_000__13.png": 13,
  "/assets/spells/tile-fx/rock_falling_stack_000__9.png": 9,
  "/assets/spells/tile-fx/great-roar.png": 10,
  "/assets/spells/tile-fx/powder_green_002__22.png": 22,
  "/assets/spells/tile-fx/powder_green_001__22.png": 22,
  "/assets/spells/tile-fx/powder_green_000__22.png": 22,

  // CHARGING VFX
  "/assets/spells/self/spellcast-a-pink.png": 18,
  "/assets/spells/self/powerup-1.png": 9,

  // IMPACT VFX - Melee 2
  "/assets/spells/impact/impfx2_fantasy_impact_A_large_orange.png": 8,
  "/assets/spells/fx/fanfx2_fire_spell_large_red.png": 23,
  "/assets/spells/impact/tiny-green-1.png": 9,
  "/assets/spells/impact/tiny-white-1.png": 9,
  "/assets/spells/impact/tiny-black-1.png": 9,
  "/assets/spells/impact/tiny-red-1.png": 9,
  "/assets/spells/impact/tiny-blue-1.png": 9,
  "/assets/spells/impact/tiny-yellow-1.png": 9,
  "/assets/spells/impact/tiny-pink-1.png": 9,
  "/assets/spells/impact/tiny-orange-1.png": 9,
  "/assets/spells/impact/tiny-gray-1.png": 9,
  "/assets/spells/impact/melee-red-3.png": 6,
  "/assets/spells/impact/impact-toon-c-red.png": 8,

  // SHIELD VFX
  "/assets/spells/self/shield-1-blue.png": 20,
  "/assets/spells/self/shield-1-green.png": 20,
  "/assets/spells/self/shield-1-red.png": 20,
  "/assets/spells/self/shield-1-yellow.png": 20,
  "/assets/spells/self/shield-1-pink.png": 20,
  "/assets/spells/self/shield-1-orange.png": 20,
  "/assets/spells/self/shield-1-white.png": 20,

  // HEALING VFX
  "/assets/spells/self/healing-1-blue.png": 17,
  "/assets/spells/self/healing-1-green.png": 17,
  "/assets/spells/self/healing-1-red.png": 17,
  "/assets/spells/self/healing-1-yellow.png": 17,
  "/assets/spells/self/healing-1-pink.png": 17,
  "/assets/spells/self/healing-1-orange.png": 17,
  "/assets/spells/self/healing-1-white.png": 17,
  "/assets/spells/self/healing-2-green.png": 8,
  "/assets/spells/self/healing-2-blue.png": 8,
  "/assets/spells/self/healing-2-white.png": 8,

  // CHARGE
  "/assets/spells/self/charge-1.png": 8,
  "/assets/spells/self/charge-1-white.png": 8,
  "/assets/spells/processed/6-processed.png": 3,

  // PARTICLE VFX
  "/assets/spells/particle/pin.png": 1,
  "/assets/spells/particle/bug-1.png": 1,
  "/assets/spells/particle/rock-1.png": 1,
  "/assets/spells/particle/fire-1.png": 4,
  "/assets/spells/particle/ice-1.png": 1,
  "/assets/spells/particle/water-1.png": 4,
  "/assets/spells/particle/electric-1.png": 4,
  "/assets/spells/particle/bell_ring_and_sounds_004__18.png": 18,
  "/assets/spells/particle/flowers_000__26.png": 26,

  // SLASH PROJECTILE VFX
  "/assets/spells/projectile/slash-red.png": 6,
  "/assets/spells/projectile/slash-blue.png": 6,
  "/assets/spells/projectile/slash-green.png": 6,
  "/assets/spells/projectile/slash-yellow.png": 6,
  "/assets/spells/projectile/slash-pink.png": 6,
  "/assets/spells/projectile/slash-orange.png": 6,
  "/assets/spells/projectile/slash-white.png": 6,
  "/assets/spells/projectile/slash-black.png": 6,

  // VFX
  "/assets/spells/vfx/fear_000__19.png": 19,
  "/assets/spells/vfx/moonblast.png": 5,
  "/assets/spells/vfx/night-daze.png": 5,
  "/assets/spells/vfx/sunny-day.png": 5,
  "/assets/spells/vfx/steel-bomb-blue.png": 16,
  "/assets/spells/vfx/self_sparkles_000__48.png": 48,
  "/assets/spells/vfx/self_sparkles_006__50.png": 50,
  "/assets/spells/vfx/stars_effect_000__40.png": 40,
  "/assets/spells/vfx/stars_effect_001__40.png": 40,
  "/assets/spells/vfx/paw_status_000__6.png": 6,
  "/assets/spells/vfx/scary_face_000__18.png": 18,
  "/assets/spells/vfx/scary_face_001__9.png": 9,
  "/assets/spells/self/self_sparkles_003__26.png": 26,
  "/assets/spells/self/self_sparkles_006__50.png": 50,
  "/assets/spells/self/self-buff-green_17.png": 17,
  "/assets/spells/vfx/bug_weeb_002__11.png": 11,
  "/assets/spells/vfx/leaves_012__23.png": 23,
  "/assets/spells/vfx/spheresbuff__21.png": 21,
  "/assets/spells/vfx/self_bubbles_001__33.png": 33,
  "/assets/spells/vfx/self_bubbles_000__20.png": 20,
  "/assets/spells/vfx/spoon__12.png": 12,
  "/assets/spells/vfx/bluecirclespin__24.png": 24,
  "/assets/spells/self/techaura__24.png": 24,
  "/assets/spells/vfx/circlesaw__15.png": 15,
  "/assets/spells/vfx/leaves_009__27.png": 27,

  // GLOBAL BUFF/DEBUFF VFX
  "/assets/spells/vfx/bugbuff__9.png": 9,
  "/assets/spells/vfx/grassbuff__26.png": 26,
  "/assets/spells/vfx/yellow-sparkles__11.png": 11,
  "/assets/spells/vfx/white-star-buff__12.png": 12,
  "/assets/spells/vfx/galaxyorb__36.png": 36,
  "/assets/spells/vfx/whiteredbuff__21.png": 21,
  "/assets/spells/vfx/poisontrap__13.png": 13,
  "/assets/spells/vfx/hurrican-leaves__51.png": 51,
  "/assets/spells/vfx/rock-impact__11.png": 11,
  "/assets/spells/vfx/roar__12.png": 12,
  "/assets/spells/vfx/steelsaw__17.png": 17,
  "/assets/spells/vfx/pinkcharge__42.png": 42,
  "/assets/spells/vfx/charge__14.png": 14,
  "/assets/spells/vfx/spellcast__39.png": 39,
  "/assets/spells/vfx/spellcast-b__39.png": 39,

  // TACTICAL SKILLS VFX
  "/assets/spells/impact/impfx2_fantasy_impact_A_large_red.png": 8,
  "/assets/spells/impact/melee-fighting-1.png": 5,
  "/assets/spells/impact/impfx2_scifi_impact_A_large_violet.png": 10,
  "/assets/spells/impact/impfx2_fantasy_impact_A_large_white.png": 8,
  "/assets/spells/projectile/ghost-1.png": 8,
  "/assets/spells/projectile/water-2.png": 10,
  "/assets/spells/vfx/bell_ring_and_sounds_008__16.png": 16,
  "/assets/spells/vfx/bell_ring_and_sounds_001__18.png": 18,
  "/assets/spells/tile-fx/pj4_sawblade_small_gray.png": 8,

  // EXPLOSION
  "/assets/spells/explosion/expfx1_stylized_explosion_C_large_blue.png": 14,

  // CLAWS
  "/assets/spells/claws/fanfx2_claw_large_yellow.png": 13,
  "/assets/spells/claws/fx2_claw_large_black.png": 10,
  "/assets/spells/claws/fx2_claw_large_blue.png": 10,
  "/assets/spells/claws/fx2_claw_large_green.png": 10,
  "/assets/spells/claws/fx2_claw_large_orange.png": 10,
  "/assets/spells/claws/fx2_claw_large_red.png": 10,
  "/assets/spells/claws/fx2_claw_large_violet.png": 10,
  "/assets/spells/claws/fx2_claw_large_white.png": 10,
  "/assets/spells/claws/fx2_claw_large_yellow.png": 10,
  "/assets/spells/claws/fanfx2_claw_large_black.png": 13,
  "/assets/spells/claws/fanfx2_claw_large_blue.png": 13,
  "/assets/spells/claws/fanfx2_claw_large_green.png": 13,
  "/assets/spells/claws/fanfx2_claw_large_orange.png": 13,
  "/assets/spells/claws/fanfx2_claw_large_pink.png": 13,
  "/assets/spells/claws/fanfx2_claw_large_red.png": 13,
  "/assets/spells/claws/fanfx2_claw_large_violet.png": 13,
  "/assets/spells/claws/fanfx2_claw_large_white.png": 13,
};
